(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/grid/assets/javascripts/debug.js') >= 0) return;  svs.modules.push('/components/tur/grid/assets/javascripts/debug.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const env = svs.core.config.data.svsconfig.env;
const Icon = svs.ui.ReactIcon;
const Debug = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showGrid = _useState2[0],
    setShowGrid = _useState2[1];
  if (env === 'production') {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tur-grid-toggle ".concat(showGrid ? 'tur-grid-toggle--active' : ''),
    onClick: () => setShowGrid(prevState => !prevState),
    type: "div"
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: "rows"
  })), React.createElement("div", {
    className: "tur-debug-grid ".concat(showGrid ? 'tur-grid--show' : '')
  }, React.createElement("div", {
    className: "grid-wrapper"
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  }))))), React.createElement("div", {
    className: "grid-cols-wrapper"
  }, React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })))));
};
svs.tur.grid.Debug = Debug;

 })(window);